<template>
  <div>
    <i class="icon-cross icon-x" @click="close()"></i>
    <div class="l-row" v-for="type in Object.keys(message)" v-if="message[type] && message[type].length">
      <div class="margin">
        <strong>{{ $t(`${type}.label`) }}</strong>
        <div class="l-col-12@md">
          <span v-html="getMessageStatus(message[type])"></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data: () => ({
      message: {
        product: null,
        price: null,
        stock: null,
        image: null
      }
    }),
    props: {
      product: {
        type: Object,
        required: true
      },
      module: {
        type: Object,
        required: true
      }
    },
    created () {
      if (this.module.identifier === 'mercadoLivre') {
        this.message.product = this.product.message
        this.message.price = this.product.variations[0].price.message
        this.message.stock = this.product.variations[0].stock.message
      } else {
        this.message.product = this.product.message
        this.message.price = this.product.price.message
        this.message.stock = this.product.stock.message
        this.message.image = this.product.imageErrorMessage || this.product.imageStatusMessage
      }
    },
    methods: {
      getMessageStatus (message) {
        return message.replace('\n', '<br>- ')
      },
      close () {
        this.$emit('close', false)
      }
    }
  }
</script>

<style lang="sass" scoped>
  .icon-x
    float: right
    margin-right: 8px
    font-size: 12px
    cursor: pointer

  .margin
    margin: 10px 0 15px 10px

</style>



// WEBPACK FOOTER //
// StatusMessageCard.vue?8289f232